import { useEffect, useState } from 'react';
import { defaultErrorHandler } from 'api';
import { InterventionsApi } from '../api';
import { Intervention } from '../types';

interface FetchedIntervention {
  intervention : Intervention | null | undefined;
  isFetched: boolean;
  isFetching: boolean; 
}

export const useFetchIntervention = (id: number | null) : FetchedIntervention => {
  const [intervention, setIntervention] = useState<Intervention | null | undefined>(undefined);
  const [isFetched, setIsFetched] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    setIsFetching(true);

    if (id === null) {
      setIntervention(null);
    } else {
      InterventionsApi.getById(id)
        .then((fetchedIntervention) => {
          setIntervention(fetchedIntervention);
          setIsFetched(true);
        })
        .catch((error) => {
          setIntervention(null);
          setIsFetched(false);
          defaultErrorHandler(error);
        })
        .finally(() => setIsFetching(false));
    }
  }, [id]);

  return {intervention, isFetched, isFetching};
};
